import styled from '@emotion/styled'
import { useAtomValue } from 'jotai'
import { Colors } from 'src/components/theme'
import { isFeatureEnabled } from 'src/utils/feature-flag'
import { formatVal } from 'src/utils/number-format'
import { Chip } from 'src/v2/components/chip'
import { DescriptionItem } from 'src/v2/components/description-item'

import * as atoms from 'src/v2/state/owner-reveal/entity-summary'
import { FC } from 'react'
import { formatString } from 'src/utils/format-string'
import { format } from 'date-fns'

const Content = styled.div`
  display: flex;
  gap: 16px;
`

const Column = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 8px;
`

type AcquisitionsOverviewContentProps = {
  entityId: string
  noDataContent?: JSX.Element
}

export const OwnerSummaryContent: FC<AcquisitionsOverviewContentProps> = ({ entityId, noDataContent = null }) => {
  const summary = useAtomValue(atoms.entitySummaryById(entityId))
  const isOwnerRevealMockDataEnabled = isFeatureEnabled('owner-reveal-mock-data')

  if (!summary) {
    return noDataContent
  }

  return (
    <Content>
      <Column>
        <DescriptionItem label="Contacts" value={summary.amountOfContacts} />
        <DescriptionItem label="Company Type" value={summary.companyType} />
        <DescriptionItem label="Associated Address" value={formatString(summary.address, 'address')} />
        {isOwnerRevealMockDataEnabled && (
          <DescriptionItem
            label="Activity"
            value={
              summary.activity ? (
                <Chip iconColor={Colors.rankGreen400} backgroundColor={Colors.rankGreen100}>
                  {summary.activity}
                </Chip>
              ) : null
            }
          />
        )}
      </Column>
      <Column>
        <DescriptionItem
          label="Portfolio Value"
          value={summary.portfolioValue ? formatVal(summary.portfolioValue, 'currency-long') : null}
        />
        {isOwnerRevealMockDataEnabled && <DescriptionItem label="Recent Acquisition" value="Month XX, 20XX" />}
        {/* TODO: Fix me */}
        <DescriptionItem
          label="Incorporation Date"
          value={summary.incorporationDate ? format(new Date(summary.incorporationDate), 'MMMM dd, yyyy') : ''}
        />
        {isOwnerRevealMockDataEnabled && <DescriptionItem label="Last Activity" value="X months ago" />}
      </Column>
    </Content>
  )
}
